import { memo } from 'react';

import MemberAvatar from '../../shared/MemberAvatar.jsx';

/** Name, email and profile line of a person in "Before you add them". */
function BlockerPerson({ person, label, avatar = false }) {
  const name = `${person.first_name} ${person.last_name}`.trim() || person.email;
  const profile = [person.job_title, person.location].filter(Boolean).join(' · ');
  const details = (
    <div className="flex min-w-0 flex-col gap-0.5">
      {label ? <span className="text-xs text-content-muted">{label}</span> : null}
      <span className="truncate text-sm font-semibold text-content">{name}</span>
      <span className="truncate text-xs text-content-secondary">{person.email}</span>
      {profile ? <span className="truncate text-xs text-content-muted">{profile}</span> : null}
    </div>
  );
  if (!avatar) return details;
  return (
    <div className="flex min-w-0 items-center gap-3">
      <MemberAvatar member={{ displayName: name, name, email: person.email }} size="md" />
      {details}
    </div>
  );
}

export default memo(BlockerPerson);
